export const domainConstants = {
  REGISTER_DOMAIN_REQUEST: 'STATUS_REGISTER_DOMAIN_REQUEST',
  REGISTER_DOMAIN_SUCCESS: 'STATUS_REGISTER_DOMAIN_SUCCESS',
  REGISTER_DOMAIN_FAILURE: 'STATUS_REGISTER_DOMAIN_FAILURE',

  VERIFY_DOMAIN_REQUEST: 'DASHBOARD_VERIFY_DOMAIN_REQUEST',
  VERIFY_DOMAIN_SUCCESS: 'DASHBOARD_VERIFY_DOMAIN_SUCCESS',
  VERIFY_DOMAIN_FAILURE: 'DASHBOARD_VERIFY_DOMAIN_FAILURE',

  VERIFY_SCRIPT_GERO_REQUEST: 'VERIFY_SCRIPT_GERO_REQUEST',
  VERIFY_SCRIPT_GERO_SUCCESS: 'VERIFY_SCRIPT_GERO_SUCCESS',
  VERIFY_SCRIPT_GERO_FAILURE: 'VERIFY_SCRIPT_GERO_FAILURE',

  DOMAIN_REMOVAL_REQUEST: 'DOMAIN_REMOVAL_REQUEST',
  DOMAIN_REMOVAL_SUCCESS: 'DOMAIN_REMOVAL_SUCCESS',
  DOMAIN_REMOVAL_FAILURE: 'DOMAIN_REMOVAL_FAILURE',

  DOMAIN_UPDATE_REQUEST: 'DOMAIN_UPDATE_REQUEST',
  DOMAIN_UPDATE_SUCCESS: 'DOMAIN_UPDATE_REQUEST',
  DOMAIN_UPDATE_FAILURE: 'DOMAIN_UPDATE_FAILURE',

  DOMAIN_CHANGE_REQUEST: 'DOMAIN_CHANGE_REQUEST',
  DOMAIN_CHANGE_SUCCESS: 'DOMAIN_CHANGE_SUCCESS',
  DOMAIN_CHANGE_FAILURE: 'DOMAIN_CHANGE_FAILURE'
}
